export enum SaveMode {
  None,
  Session,
  Local
}
